<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <cmp-site-select
              ref="selectSIT"
              :pageId="this.$options.name"
              :selected="frame0.selectData.SIT"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onResetClick"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
            <sui-button
              v-permission:read="'PGE_CMY_00020'"
              type="button"
              class="comm_btn_Scr"
              @click="onSearchClick"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="comm_shut_wrap">
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4 class="comm_tit02">
              {{ $t("MSG_TXT_SITE") }}
            </h4>
          </div>
          <sui-grid
            ref="grid"
            :showDisplayCountControl="false"
            :columns="gridColumns0"
            :dataset="'dataset0'"
            :initialPagesize="10"
          />
        </div>
        <div class="btnbox" />
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4 class="comm_tit02">
              {{ $t("MSG_TXT_APPLY_WORK") }}
            </h4>
          </div>
          <div class="comm_gridTop_wrap">
            <div class="btn_wrapR">
              <div class="module_grid_print copy-site">
                <cmp-site-select
                  ref="selectSITE"
                  :pageId="this.$options.name"
                  :selected="frame0.selectData.SITE"
                  :defaultOption="'select'"
                  :initialSelectedIndex="0"
                />
              </div>
              <div class="div_line" />
              <sui-button
                type="button"
                class="comm_btn_gridTop"
                @click="onChanged"
              >
                {{ $t("MSG_BTN_GET") }}
              </sui-button>
            </div>
          </div>
          <sui-tree-grid
            ref="treeGrid01"
            :columns="treeGridColumns01"
            :height="395"
            :dataset="'dataset1'"
            :selectionMode="'singleRow'"
            :checkboxes="true"
            :hierarchicalCheckboxes="false"
            @rowCheck="onRowCheckTreeGrid"
            @rowUncheck="onRowUncheckTreeGrid"
          />
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:download="'PGE_CMY_00020'"
          type="button"
          class="comm_btn_border_Prime comm_ico_excel"
          @click="onDownloadExcel"
        >
          {{ $t("MSG_BTN_EXCEL_DOWN") }}
        </sui-button>
        <sui-button
          v-permission:update="'PGE_CMY_00020'"
          type="button"
          class="comm_btn_solid"
          @click="onSave"
        >
          {{ $t("MSG_BTN_SAVE") }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['firstRegistrationDTM', 'finalModificationDTM'];

export default {
  name: 'PGE_CMY_00020', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      localLangId: this.$store.getters.userInfo.langId,
      // Codes
      pageName: 'PGE_CMY_00020',
      codes: CommonConstants.selectOptions(),
      frame0: {
        selectData: {
          // Codes
          SIT: {
            key: '',
            label: '',
          },
          SITE: {
            key: '',
            label: '',
          },
        },
      },
      localdata0: [],
      localdata1: [],
      localdata1_ori: [],
      saveMode: 'create', // 최초 생성 판단
      gridColumns0: [{
        text: this.$t('MSG_TXT_GNRZ_AREA'),
        datafield: 'gnrzAreaName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SITE_ID'),
        datafield: 'siteId',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_SITE_ABBR'),
        datafield: 'siteAbbName',
      }],
      gridColumns1: [{
        text: this.$t('MSG_TXT_GNRZ_AREA'),
        datafield: 'gnrzAreaName',
      }, {
        text: this.$t('MSG_TXT_SITE_ID'),
        datafield: 'siteId',
      }, {
        text: this.$t('MSG_TXT_SITE_ABBR'),
        datafield: 'siteAbbName',
      }, {
        text: this.$t('MSG_TXT_WORK_NM'),
        datafield: 'taskName',
      }, {
        text: this.$t('MSG_TXT_WORK_CD'),
        datafield: 'lvlTaskId',
      },
      // {
      //   text: this.$t('MSG_TXT_WORK_CONTENTS'),
      //   datafield: 'taskContents',
      //   hidden: true,
      // },
      {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'userName',
        width: 100,
      },
      {
        text: this.$t('MSG_TXT_KNOX_ID'),
        datafield: 'knoxId',
        width: 150,
      },
      {
        text: this.$t('MSG_TXT_FNL_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: 150,
      }],
      treeGridColumns01: [
        {
          text: this.$t('MSG_TXT_WORK_NM'),
          datafield: 'taskName',
          // width: 270,
        }, {
          text: this.$t('MSG_TXT_WORK_CD'),
          datafield: 'lvlTaskId',
          width: 80,
        },
        // {
        //   text: this.$t('MSG_TXT_WORK_CONTENTS'),
        //   datafield: 'taskContents',
        //   cellsrenderer: this.cellsrenderer,
        //   hidden: true,
        // },
        {
          text: this.$t('MSG_TXT_MDFC_USR'),
          datafield: 'userName',
          width: 90,
        },
        {
          text: this.$t('MSG_TXT_KNOX_ID'),
          datafield: 'knoxId',
          width: 100,
        },
        {
          text: this.$t('MSG_TXT_FNL_MDFC_DTM'),
          datafield: 'finalModificationDTM',
          width: 140,
          // eslint-disable-next-line max-len
          cellsrenderer: (r, c, v) => `<div class="jqx-grid-cell-left-align" style="margin-top: 10.5px;">${utils.dateformatToClient(v)}</div>`,
        },
      ],
      // TreeGrid 데이타셋1의 로컬데이터
      stateData: [],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'gnrzAreaName',
      type: 'string',
      map: 'gnrzAreaName',
    }, {
      name: 'siteId',
      type: 'string',
      map: 'siteId',
    }, {
      name: 'siteAbbName',
      type: 'string',
      map: 'siteAbbName',
    }],
  }, {
    id: 'dataset1',
    componentType: 'tree-grid',
    data: 'localdata1',
    hierarchy: {
      keyDataField: {
        name: 'taskId',
      },
      parentDataField: {
        name: 'parentTaskId',
      },
    },
    datafields: [{
      name: 'gnrzAreaName',
      type: 'string',
      map: 'gnrzAreaName',
    }, {
      name: 'siteId',
      type: 'string',
      map: 'siteId',
    }, {
      name: 'siteAbbName',
      type: 'string',
      map: 'siteAbbName',
    }, {
      name: 'taskName',
      type: 'string',
      map: 'taskName',
    }, {
      name: 'taskId',
      type: 'string',
      map: 'taskId',
    },
    // {
    //   name: 'taskContents',
    //   type: 'string',
    //   map: 'taskContents',
    // },
    {
      name: 'parentTaskId',
      type: 'string',
      map: 'parentTaskId',
    }, {
      name: 'dataset-row-id',
      type: 'string',
      map: 'dataset-row-id',
    }, {
      name: 'taskApplyYn',
      type: 'string',
      map: 'taskApplyYn',
    }, {
      name: 'taskApplyUseYn',
      type: 'string',
      map: 'taskApplyUseYn',
    }, {
      name: 'lvlTaskId',
      type: 'string',
      map: 'lvlTaskId',
    }, {
      name: 'userName',
      type: 'string',
      map: 'userName',
    }, {
      name: 'knoxId',
      type: 'string',
      map: 'knoxId',
    }, {
      name: 'finalModificationDTM',
      type: 'string',
      map: 'finalModificationDTM',
    }],
  }, {
    id: 'dataset2',
    type: 'local',
    data: 'localdata1',
    datafields: [{
      name: 'gnrzAreaName',
      type: 'string',
      map: 'gnrzAreaName',
    }, {
      name: 'siteId',
      type: 'string',
      map: 'siteId',
    }, {
      name: 'siteAbbName',
      type: 'string',
      map: 'siteAbbName',
    }, {
      name: 'taskName',
      type: 'string',
      map: 'taskName',
    }, {
      name: 'taskId',
      type: 'string',
      map: 'taskId',
    },
    // {
    //   name: 'taskContents',
    //   type: 'string',
    //   map: 'taskContents',
    // },
    {
      name: 'taskApplyYn',
      type: 'string',
      map: 'taskApplyYn',
    }, {
      name: 'taskApplyUseYn',
      type: 'string',
      map: 'taskApplyUseYn',
    }, {
      name: 'lvlTaskId',
      type: 'string',
      map: 'lvlTaskId',
    }, {
      name: 'userName',
      type: 'string',
      map: 'userName',
    }, {
      name: 'knoxId',
      type: 'string',
      map: 'knoxId',
    }, {
      name: 'finalModificationDTM',
      type: 'string',
      map: 'finalModificationDTM',
    }],
  }],
  mounted() {
    this.dataset0.$on(this.dataset0.EVENTS.SELECTION_CHANGED, this.onselectGrid);
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    cellsrenderer(row, columnfield, value) {
      if (value.length > 15) {
        // console.log(value);
        let taskContents = value;
        taskContents = taskContents.replace(/(\s*)/g, '');
        taskContents = taskContents.replace(/(.{15})/g, '$1&#10;');

        return `<span title=${taskContents}>${value}</span>`;
      }
      return `<span>${value}</span>`;
    },
    onSearchClick() {
      const codeValue = this.frame0.selectData;
      const queryParams = {
        searchSiteCode: utils.trim(codeValue.SIT.key) || '',
      };

      http.request(this.$options.name, 'DTS_CMY_00039', {
        query: queryParams,
      }).then(res => {
        this.localdata0 = res.data;
        this.dataset0.setRawData(this.localdata0);
        this.dataset0.clearSelection();
      }).catch(error => {
        console.log(error);
      });
    },
    onResetClick() {
      this.$refs.selectSIT.reset();
    },
    onDownloadExcel() {
      const metaObj = {
        // "headerTitle" : {
        //   "codeName" : this.$t('MSG_TXT_CODE_NAME'),
        //   "codeEngName" : this.$t('MSG_TXT_CODE_ENAME'),
        //   "codeAbb" : this.$t('MSG_TXT_ABBR'),
        // },
        headerFontSize: 16,
        headerFontColor: 1,
        headerForegroundColor: 22,
      };

      const selectedIndexes = this.dataset0.getSelectedIndexes();
      const queryParams = {
        excelDownFlag: 'Y' || '',
      };
      let selSiteId = '';

      selSiteId = this.dataset0.data[selectedIndexes].siteId;
      http.request(this.$options.name, 'DTS_CMY_00040', {
        path: {
          'site-id': selSiteId,
        },
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);
        // this.localdata1 = res.data;
        // this.dataset2.setRawData(this.localdata1);
        this.dataset2.setRawData(res.data);

        const sPageId = this.$options.name;
        const objGridColumns = this.gridColumns1;
        const objGridDataset = this.dataset2;
        const sToday = utils.now('YYYYMMDDHHmmss');
        const sExcelName = `apply-work-list_${sToday}.xlsx`;

        utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, metaObj);
      }).catch(error => {
        console.log(error);
      });
    },
    onselectGrid() {
      const selectedIndexes = this.dataset0.getSelectedIndexes();
      let selSiteId = '';

      if (selectedIndexes.length < 1) {
        return;
      }

      selSiteId = this.dataset0.data[selectedIndexes].siteId;
      http.request(this.$options.name, 'DTS_CMY_00040', {
        path: {
          'site-id': selSiteId,
        },
      }).then(res => {
        // create 인지 update인지 조건 결정
        // const totalRow = utils.size(res.data);
        // const saveRow = utils.size(utils.filter(res.data, row => row.siteId));
        // this.saveMode = totalRow === saveRow ? 'update' : 'create';

        this.localdata1 = this._setExtendInfo(res.data);
        this.localdata1_ori = utils.cloneDeep(this.localdata1); // backup for compare

        this.dataset1.setRawData([]);
        this.dataset1.setRawData(this.localdata1);

        const treeGridRows = this.$refs.treeGrid01.getJqxTreeGrid().getRows();

        this.setTreeGridCheckbox(treeGridRows); // set checkbox
      }).catch(error => {
        console.log(error);
      });
    },
    _setExtendInfo(list) {
      utils.forEach(list, data => {
        const result = {};
        result.taskApplyUseYn = data.taskApplyUseYn || 'Y'; // N = check, Y = uncheck
        if (utils.isEmpty(data.userName) !== true && utils.isEmpty(data.knoxId) !== true) {
          // const userInfo = data.finalModificationUserInfo;
          result.userName = this.localLangId === 'ko' ? data.userName : data.userGlobalName;
          result.knoxId = data.knoxId;
        } else {
          result.userName = '';
          result.knoxId = '';
        }
        utils.assign(data, result);
      });
      return list;
    },
    setTreeGridCheckbox(treeGridData) {
      utils.forEach(treeGridData, item => {
        // if (item.siteId) {
        if (item.taskApplyUseYn === 'N') { // N = checked
          this.$refs.treeGrid01.getJqxTreeGrid().checkRow(item.uid, true);
        }
        if (item.records) {
          this.$refs.treeGrid01.getJqxTreeGrid().expandRow(item.uid, true);
          this.setTreeGridCheckbox(item.records);
        }
      });
    },
    onSave() {
      const dataParams = [];
      let saveRows = [];

      // if (this.saveMode === 'create') {
      //   saveRows = this.localdata1;
      // } else { // update
      const tmpArr = [];
      utils.forEach(this.localdata1, (item, index) => {
        if (this.localdata1_ori[index].taskApplyUseYn !== item.taskApplyUseYn) {
          tmpArr.push(item);
        }
      });
      saveRows = tmpArr;
      // }

      const selectedIndexes = this.dataset0.getSelectedIndexes();

      utils.forEach(saveRows, item => {
        dataParams.push({
          siteId: this.dataset0.data[selectedIndexes].siteId,
          taskId: item.taskId,
          taskApplyUseYn: item.taskApplyUseYn,
          // saveMode: this.saveMode,
        });
      });

      // const targetUrl = this.saveMode === 'create' ? 'DTS_CMY_00088' : 'DTS_CMY_00041';
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        // console.log(this.$options.name);
        http.request(this.$options.name, 'DTS_CMY_00041', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
            // 저장 후 재 로드
            const rowNum = this.$refs.grid.getJqxGrid().getselectedrowindex();
            this.onselectGrid(rowNum);
          });
        }).catch(error => {
          console.log(error);
        });
      });
    },
    onChanged() {
      const codeValue = this.frame0.selectData;
      let selSiteId = '';

      selSiteId = utils.trim(codeValue.SITE.key);

      if (this.dataset1.data.length < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_INFO_SRCH'));
        return;
      }

      if (selSiteId.length < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_IS_COPY_SELT_SITE'));
        return;
      }

      utils.messageBox('confirm', this.$t('MSG_ALT_IS_COPY_DATA'), null, () => {
        http.request(this.$options.name, 'DTS_CMY_00040', {
          path: {
            'site-id': selSiteId,
          },
        }).then(res => {
          this.localdata1_ori = utils.cloneDeep(this.localdata1); // backup for compare
          this.localdata1 = this._setExtendInfo(res.data);

          this.dataset1.setRawData([]);
          this.dataset1.setRawData(this.localdata1);

          const treeGridRows = this.$refs.treeGrid01.getJqxTreeGrid().getRows();

          this.setTreeGridCheckbox(treeGridRows); // set checkbox

          utils.messageBox('success', this.$t('MSG_ALT_COPY_DATA'), null);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    onRowCheckTreeGrid(e) {
      this._rowCheck(e.args.row.uid, 'N');
      this._downCheck(e.args.row);
      this._upCheck(e.args.row);
    },
    onRowUncheckTreeGrid(e) {
      this._rowCheck(e.args.row.uid, 'Y');
      this._downCheck(e.args.row);
      this._upCheck(e.args.row.parent);
    },
    _downCheck(obj) {
      utils.forEach(obj.records, item => {
        if (obj.checked) {
          this.$refs.treeGrid01.getJqxTreeGrid().checkRow(item.uid, true);
          this._rowCheck(item.uid, 'N');
        } else {
          this.$refs.treeGrid01.getJqxTreeGrid().uncheckRow(item.uid, true);
          this._rowCheck(item.uid, 'Y');
        }

        if (item.records) {
          this._downCheck(item);
        }
      });
    },
    _upCheck(obj) {
      if (obj) {
        this.$refs.treeGrid01.getJqxTreeGrid().checkRow(obj.uid, true);
        this._rowCheck(obj.uid, 'N');

        if (obj.parent) {
          this._upCheck(obj.parent);
        }
      }
    },
    _rowCheck(uid, value) {
      const rowNum = utils.findIndex(this.localdata1, { 'dataset-row-id': uid });
      this.localdata1[rowNum].taskApplyUseYn = value;
    },
  },
};
</script>
<style>
  .copy-site .dp_flex .sui-select {
    width:200px !important;
  }
  .comm_shut_wrap .inbox1 { flex: 1 1 30%; align-self: auto; }
  .comm_shut_wrap .inbox2 { flex: 1 1 70%; align-self: auto; }
</style>
